<template>
  <section id="home-laptops-mobile">
    <div v-for="type in types"
      :key="type.slug"
      class="product-type">
      <div class="product-type-header">
        <h4>{{ type.title }}</h4>
        <router-link :to="`/products/${type.slug}`">
          Show all
        </router-link>
      </div>

      <perfect-scrollbar class="product-type-list">
        <CardProduct
          v-for="item in type.products"
          :key="item.id"
          :data="item" />
      </perfect-scrollbar>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeProductsMobile',

  data() {
    return {
      products: {
        mainstream: [],
        premium: [],
        gaming: [],
      },

      types: [
        {
          title: 'Mainstream',
          slug: 'mainstream',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi possimus quia voluptatibus praesentium aperiam voluptatem sint cupiditate velit debitis doloribus, quidem ex eveniet reprehenderit nulla nesciunt illum perferendis fugiat corporis.',
          products: [],
        },
        {
          title: 'Premium',
          slug: 'premium',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi possimus quia voluptatibus praesentium aperiam voluptatem sint cupiditate velit debitis doloribus, quidem ex eveniet reprehenderit nulla nesciunt illum perferendis fugiat corporis.',
          products: [],
        },
        {
          title: 'Gaming',
          slug: 'gaming',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quasi possimus quia voluptatibus praesentium aperiam voluptatem sint cupiditate velit debitis doloribus, quidem ex eveniet reprehenderit nulla nesciunt illum perferendis fugiat corporis.',
          products: [],
        },
      ],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.types[0].products = await this.fetchProducts('mainstream');
      this.types[1].products = await this.fetchProducts('premium');
      this.types[2].products = await this.fetchProducts('gaming');
    },

    fetchProducts(type) {
      const params = {
        type_laptop: [type],
      };

      return this.$mainApi.get('products', { params })
        .then((res) => res.data.data.result.data);
    },
  },
};
</script>

<style lang="scss">
  #home-laptops-mobile {
    background-color: $white-fade;
    padding: 1rem 0;

    .product-type {
      margin: 1rem 0;
      overflow: hidden;
    }

    .product-type-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 1rem;
      margin-bottom: 0.75rem;

      h4 {
        font-size: 1rem;
        margin: 0;
      }

      a {
        font-size: 0.75rem;
        font-weight: bold;
        color: $color-primary;
      }
    }

    .product-type-list {
      display: flex;
      margin: 0;
      padding-left: 1rem;
      padding-bottom: 0.75rem;
      width: 100%;

      .card-product {
        min-width: calc(47vw - 10px);
        margin: 0 0.5rem 0 0;
      }
    }
  }
</style>
